module.exports = __webpack_public_path__ + "img/state_pin.581de955.svg";